const DENSE_SCREEN_SHORT_SIDE = 1024;

function isTouchDevice() {
  return window.matchMedia('(pointer: coarse)').matches;
}

function screenShortSide() {
  return Math.min(window.screen.width, window.screen.height);
}

export function applyDeviceDensity() {
  const dense = isTouchDevice() && screenShortSide() < DENSE_SCREEN_SHORT_SIDE;
  if (!dense) return;

  document.documentElement.dataset.density = 'dense';
}
